import { Box, Button, LinearProgress, Stack, Typography, useTheme } from '@mui/material'

interface BottomActionsProps {
  currentStep: number
  totalSteps: number
  onCancel: () => void
  onAnalyze: () => void
  isAnalyzeDisabled: boolean
}

export const BottomActions = ({
  currentStep,
  totalSteps,
  onCancel,
  onAnalyze,
  isAnalyzeDisabled,
}: BottomActionsProps) => {
  const theme = useTheme()
  const progress = (currentStep / totalSteps) * 100

  const getProgressColor = () => {
    if (progress <= 30) return theme.palette.error.main
    if (progress <= 70) return theme.palette.warning.main
    return theme.palette.success.main
  }

  return (
    <Box
      sx={{
        flexShrink: 1,
        backgroundColor: 'white',
        boxShadow: '0px -4px 8px rgba(0, 0, 0, 0.08)',
        p: 3,
      }}
    >
      <Box 
        sx={{ 
          maxWidth: 500, 
          mx: 'auto',
          display: 'flex',
          flexDirection: 'column',
          gap: 3,
        }}
      >
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center">
          <Box sx={{ flex: 1, maxWidth: 170 }}>
            <LinearProgress 
              variant="determinate" 
              value={progress} 
              sx={{
                backgroundColor: '#E6EEF4',
                '& .MuiLinearProgress-bar': {
                  backgroundColor: getProgressColor(),
                },
                height: 8,
                borderRadius: 4,
              }}
            />
          </Box>
          <Typography 
            sx={{ 
              fontSize: '12px',
              fontWeight: 500,
              ml: 1,
            }}
          >
            {currentStep}/{totalSteps}
          </Typography>
        </Stack>

        <Stack 
          direction={{ xs: 'column', md: 'row' }} 
          spacing={2} 
          justifyContent="center"
        >
          <Button
            fullWidth
            variant="outlined"
            size="large"
            onClick={onCancel}
            sx={{
                py: 1.5,
                px: 4
            }}
          >
            Cancel
          </Button>

          <Button
            fullWidth
            variant="contained"
            size="large"
            onClick={onAnalyze}
            disabled={isAnalyzeDisabled}
            sx={{
              py: 1.5,
              px: 4,

            }}
            >
            Analyze result
          </Button>

        </Stack>
      </Box>
    </Box>
  )
} 